import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

const POST_INSERT_BRAND = '/warranty/abm/api/v2/admin/options/mobile-brands/update/status';

export const useEditBrand = ({ onSuccessCallBack }) => {
  return useMutation({
    mutationFn: async (formData) => {
      const response = await POST(POST_INSERT_BRAND, formData);
      if (onSuccessCallBack) onSuccessCallBack(response);
      return response;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'แก้ไข Brand สำเร็จ',
      });
    },
  });
};
